import type { Locale } from "./config";

/** BCP-47 tags for Intl, keyed by our locale codes. */
const INTL_LOCALE: Record<Locale, string> = {
  en: "en-US",
  zh: "zh-CN",
  es: "es-ES",
};

/**
 * Format an ISO `YYYY-MM-DD` date for display in the given locale, e.g.
 * "May 20, 2026" / "2026年5月20日" / "20 de mayo de 2026".
 * Falls back to the raw ISO string if it can't be parsed.
 */
export function formatDate(locale: Locale, iso: string): string {
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return iso;
  try {
    return new Intl.DateTimeFormat(INTL_LOCALE[locale], {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(new Date(Date.UTC(y, m - 1, d)));
  } catch {
    return iso;
  }
}
